import { useMemo } from "react";
import { useTheme } from "@mui/material/styles";
import { createClasses } from "./createClasses";

export default function makeStyles(stylesInput) {
  return function useStyles(props = {}) {
    const theme = useTheme();

    return useMemo(
      () => createClasses(stylesInput, theme, props),
      [props, theme],
    );
  };
}
